import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OurTeam = () => {
  const { t } = useTranslation("about");
  return (
    <section className="padding-x md-max:px-6 md-max:py-10 flex flex-col gap-14">
      <h5 className="text-6xl md-max:text-4xl text-center font-semibold">
        {t('chairman.title').split(" ")[0]} <span className="text-[#1c75bc]">{t('chairman.title').split(" ").slice(1).join(" ")}</span>
      </h5>
      <div className="flex justify-center">
        {t("chairman.cards", { returnObjects: true }).map((member, index) => (
          <div
            key={index}
            className="relative h-[500px] overflow-hidden rounded-4xl md-max:h-100"
          >
            {member.image ? (
              <img
                src={member.image}
                alt="Team Member"
                width={530}
                height={570}
                className="h-full w-full object-cover rounded-lg"
              />
            ) : (
              <img
                src={"/team-avatar.png"}
                alt="Team Member"
                width={530}
                height={570}
                className="h-full w-full object-cover"
              />
            )}
            <div className="absolute bottom-5 left-5 flex w-[90%] items-center justify-between rounded-3xl bg-white px-8 py-6 md-max:px-5 md-max:py-4">
              <div className="flex flex-col gap-2">
                <p className="text-2xl md-max:text-xs font-medium text-black">
                  {member.name}
                </p>
                <p className="text-xl md-max:text-xs">{member.designation}</p>
              </div>
              <Link
                to={member.linkedin || "#"}
                target="_blank"
                className="flex-center size-16 md-max:size-10 rounded-full border border-gray-200"
              >
                <img
                  src={"/linkedin-icon.png"}
                  alt="LinkedIn"
                  width={28}
                  height={28}
                  className="translate-1 scale-90"
                />
              </Link>
            </div>
          </div>
        ))}
      </div>
      <h5 className="text-6xl md-max:text-4xl text-center font-semibold">
        {t('team.title').split(" ")[0]} <span className="text-[#1c75bc]">{t('team.title').split(" ").slice(1).join(" ")}</span>
      </h5>
      <div className="text-center text-xl md-max:text-sm text-gray-600 max-w-4xl mx-auto">
        {t('team.description')}
      </div>
    </section>
  );
};

export default OurTeam;
